import { render, staticRenderFns } from "./UpdateOracleCredentialsDialog.vue?vue&type=template&id=13c41360&"
import script from "./UpdateOracleCredentialsDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateOracleCredentialsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports